import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';
import { mergeMap } from 'rxjs';

export type SalesRep = {
  id: number;
  name: string;
  user_id?: string;
  created_at: string;
  updated_at: string;
};

@Injectable({
  providedIn: 'root',
})
export class SalesRepsService {
  private getAllSalesRepsUrl = environment.serverUrl + '/sales-reps/get-all';
  constructor(
    private firebaseService: FirebaseService,
    private http: HttpClient
  ) {}

  getAllSalesReps() {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<SalesRep[]>(this.getAllSalesRepsUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
      })
    );
  }
}
